import { contractSlice } from './slice';

export const { storeContract, deleteContract } = contractSlice.actions;
